<template>
  <section class="quotes--quote-header">
    <fixed-header :title="pageTitle" :listPage="'/vendorrmas'" hideNewOfferBtn>
      <template v-slot:center>
        <a class="mr-2">Contact</a>
        <div class="edit-contact-container mr-1">
          <edit-contact :companyId="vendorrma.companyId" :inlineButton="true" ref="editModal"
            @created="onContactCreated"></edit-contact>
        </div>
        <b-form-select class="w-auto mr-5" v-model="vendorrma.contactId">
          <option v-for="(select, index) in sortSelect(contacts,'firstName')" :key="index" :value="select.id">
            {{ select.firstName + ' ' + select.lastName }}</option>
        </b-form-select>
        <h6 class="mb-0 mr-2">Status:</h6>
        <a class="mr-5">{{ vendorrma.statusName }}</a>
        <h6 class="mr-2">Sales Rep:</h6>
        <b-form-select class="w-auto" v-model="vendorrma.salesRepUserId">
         <option v-for="(selectRep, indexRep) in sortSelect(salesReps)" :key="indexRep" :value="selectRep.id">
            {{ selectRep.name }} </option>
        </b-form-select>
        <span v-if="vendorrma.dateShipped" class="ml-3">
          <h6 class="mb-0 mr-2">Shipped at:</h6>
          <a class="mr-2">{{ date(vendorrma.dateShipped) }}</a>
        </span>

        <span v-if="vendorrma.purchaseOrderId" class="ml-3">
          <h6 class="mb-0 mr-2">Purchase Order No:</h6>
          <a class="selector-link" @click="$router.push({ name: 'purchaseorders.edit', params: {id: vendorrma.purchaseOrderId } })">
            {{ vendorrma.purchaseOrderId  }}
          </a>
        </span>
        <!-- <b-button size="sm" class="mr-2" @click="onCloseVRMA" v-if="!isClosedVendorRMA">Close</b-button> -->
        <span v-if="vendorrma.isAuthorized" class="ml-3">
          <h6 class="mb-0 mr-2">Authorized by:</h6>
          <a class="mr-2">{{ vendorrma.authorizedByUserFullName + ' on ' + date(vendorrma.dateAuthorized) }}</a>
        </span>
      </template>
    </fixed-header>

    <b-card class="quotes-header mb-1">
      <div class="d-flex">
        <address-selector
          @input="vendorrma.shipFromAddressId=$event.id, vendorrma.shipFromAddress=$event.newAddr"
          :value="vendorrma.shipFromAddress"
          :addressId="vendorrma.shipFromAddressId"
          title="Vendor Info"
          width="300"
          :accountId="vendorrma.companyId"
          class="mr-4"
        />
        <address-selector
          @input="vendorrma.shipToAddressId=$event.id, vendorrma.shipToAddress=$event.newAddr"
          :value="vendorrma.shipToAddress"
          :addressId="vendorrma.shipToAddressId"
          title="Return to"
          width="300"
          :accountId="vendorrma.companyId"
          class="mr-4"
        />
        <div class="d-flex flex-column header-field-width mr-3">
          <!-- <b-form-group label-cols="4" label-align="right" label="PO No.">
            <router-link :to="{
                name: 'purchaseorders.edit',
                params: { id: vendorrma.purchaseOrderId },
            }" class="mt-1">
            {{ vendorrma.purchaseOrderId }}
            </router-link>
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="RTV No.">
            <b-input-group size="sm">
              <b-form-input type="number" v-model="vendorrma.id" />
            </b-input-group>
          </b-form-group> -->
          <b-form-group label-cols="4" label-align="right" label="VRMA Date">
            <date-picker v-model="vendorrma.rmaDate" :config="datePickerOptions"></date-picker>
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="VRMA Terms">
            <b-form-select v-model="vendorrma.actionId">
              <option v-for="(type) in sortSelect(vendorRmaActions)" :key="type.name" :value="type.id">{{type.name}}</option>
            </b-form-select>
            <b-form-select v-model="vendorrma.termsId">
              <option v-for="(type) in sortSelect(vendorRmaTerms)" :key="type.name" :value="type.id">{{type.name}}</option>
            </b-form-select>
          </b-form-group>
        </div>

        <div class="d-flex flex-column header-field-width">
          <b-form-group label-cols="4" label-align="right" label="Ship Via" class="required">
            <b-form-select v-model="vendorrma.shippingProviderId" @change="onShippingAccountChange(true)" :class="{ 'is-invalid': $v.vendorrma.shippingProviderId.$error }">
              <option v-for="(select, index) in sortSelect(shippingProviders)" :key="index" :value="select.id">{{ select.name }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="Ship Method" :class="{ 'required': this.isRequiredShipDetails }">
            <b-form-select v-model="vendorrma.shippingMethodId" :class="{ 'is-invalid': $v.vendorrma.shippingMethodId.$error }">
              <option v-for="(select, index) in sortSelect(shipMethods)" :key="index" :value="select.id">{{ select.name }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="Ship On" :class="{ 'required': this.isRequiredShipDetails }">
              <b-form-select v-model="vendorrma.alwaysShipBy" @change="onShippingAccountChange(false)" :class="{ 'is-invalid': $v.vendorrma.alwaysShipBy.$error }">
                <option value="0"></option>
                <option value="1">Customer</option>
                <option value="2">House Account</option>
                <option value="3">Vendor</option>
              </b-form-select>
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="Ship Account #">
            <b-input-group size="sm">
              <b-form-input v-model="vendorrma.shippingAccountNumber" />
            </b-input-group>
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="Tracking #">
            <b-input-group size="sm">
              <b-form-input v-model="vendorrma.trackingNumber" />
            </b-input-group>
          </b-form-group>
        </div>
      </div>
    </b-card>
  </section>
</template>

<script>
  import {
    mapGetters,
    mapActions,
    mapState
  } from 'vuex';
  import moment from 'moment';
  import { DATE_FORMAT, VRMA_STATUS } from '@/shared/constants';
  import EditContact from '@/pages/Company/components/CompanyDetails/tabs/Contacts/components/EditContact/index';
  import AddressSelector from '@/shared/components/AddressSelector/index';
  import FixedHeader from '@/shared/components/FixedHeader/indexNew';
  import { dateTime, date } from '@/shared/filters';
  import { required, requiredIf, minValue } from 'vuelidate/lib/validators';
  const isMinValue = function(val) { return this.isRequiredShipDetails ? val > 0 : val == 0; }

  export default {
    components: {
      EditContact,
      AddressSelector,
      FixedHeader,
    },
    data() {
      return {
        text: '11111111',
        date,
        datePickerOptions: {
          format: DATE_FORMAT,
          useCurrent: false,
        },
        returnActions: [
          'Replacement',
          'Return & Replace',
          'Return for Credit',
          'Return'
        ]
      }
    },
    watch: {
    },
    computed: {
      ...mapState('vendorrmas', ['vendorrma']),
      ...mapState('account', ['user']),
      ...mapGetters('quoteDetails', [ 'contacts']),
      ...mapState('salesReps', ['salesReps']),
      ...mapGetters('companies', ['companyById']),
      ...mapGetters('shippingAccount', ['shippingAccountsList']),
      ...mapGetters('lookup', ['vendorRmaTerms', 'vendorRmaActions', 'shipViaList', 'shippingProviders']),

      pageTitle() {
        return `Vendor RMA: ${this.vendorRmaId} - ${this.vendorrma.companyName}`;
      },
      vendorRmaId() {
        return this.$route.params.id;
      },
      isClosedVendorRMA() {
        return this.vendorrma.statusId == VRMA_STATUS.CLOSED;
      },
      isAuthorizedVendorRMA() {
        return this.vendorrma.approvedByUserId != null && this.vendorrma.dateApproved != null;
      },
      company() {
        var result = this.companyById(this.vendorrma.companyId);
        return result;
      },
      shipMethods() {
        if (this.vendorrma.shippingProviderId) {
          return this.shipViaList.filter(ship => ship.shippingProviderId == this.vendorrma.shippingProviderId);
        } else {
          return [];
        }
      },
      isRequiredShipDetails() {
        return (this.shippingProviders.length > 0 && this.vendorrma) ? this.shippingProviders.filter(prov => prov.name != "TBD" && prov.name != "Unassigned")
          .map(x => x.id).includes(this.vendorrma.shippingProviderId) : false;
      }
    },
    methods: {
      ...mapActions('quoteDetails', ['getContacts']),
      ...mapActions('vendorrmas', ['onCloseVRMAStatus']),
      ...mapActions('salesReps', ['getSalesReps']),
      ...mapActions('companies', { getCompanyById: 'getById' }),
      ...mapActions('shippingAccount', ['getShippingAccounts']),
      async onContactCreated(id) {
        await this.getContacts(this.customerrma.accountId);
        this.vendorrma.contactId = id;
      },
      async onCloseVRMA() {
        const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to close the Vendor RMA. Once closed, no further edits can be made`});
        if (deleteConfirmed) {
          await this.onCloseVRMAStatus(this.vendorRmaId);
        }
      },
      onShippingAccountChange(isProviderChange = false) {
        if (isProviderChange) {
          let prov = this.shippingProviders.find(x => x.id == this.vendorrma.shippingProviderId);
          if (prov && prov.name == "TBD") {
            // auto set method if the provider is TBD
            let sMthd = this.shipViaList.find(x => x.shippingProviderId == this.vendorrma.shippingProviderId);
            this.vendorrma.shippingMethodId = (sMthd) ? sMthd.id : 0;
            
          } else {
            this.vendorrma.shippingMethodId = 0;
          }
        }
        // If ship by is Customer
        if (this.vendorrma.alwaysShipBy == 1) {
          const acct = this.shippingAccountsList.find(x => x.shippingProviderId == this.vendorrma.shippingProviderId);
          this.vendorrma.shippingAccountNumber = (acct != null) ? acct.accountNumber : null;
        } else {
          this.vendorrma.shippingAccountNumber = null;
        }
      },
      getHeaderValidation() {
        this.$v.$touch();
        this.$emit('header-validation', this.$v.$invalid);
      },
    },
    validations: {
      vendorrma: {
        shippingProviderId: {required},
        shippingMethodId: { 
          required: requiredIf(function() { return this.isRequiredShipDetails }),
          isMinValue
        },
        alwaysShipBy: {
          required: requiredIf(function(){ return this.isRequiredShipDetails } ),
          isMinValue

        },
      }
    },
    async mounted() {
      if(this.vendorrma.rmaDate) {
        this.vendorrma.rmaDate = moment(this.vendorrma.rmaDate).format(DATE_FORMAT);
      }
      //await this.getById(this.quoteId);
      // await this.getQuoteTerms();
      // await this.getQuoteStatuses();
      if (this.vendorrma.companyId) {
        this.getShippingAccounts(this.vendorrma.companyId);
        this.getContacts(this.vendorrma.companyId);
        if (Object.keys(this.company).length == 0) {
          this.getCompanyById(this.vendorrma.companyId);
        }
      }
      await this.getSalesReps();

      // if(this.vendorrma.dateAuthorized) {
      //   this.vendorrma.dateAuthorized = moment(this.vendorrma.dateAuthorized).format(DATE_FORMAT);
      // }

      // if(this.vendorrma.dateEmailed) {
      //   this.vendorrma.dateEmailed = moment(this.vendorrma.dateEmailed).format(DATE_FORMAT);
      // }
    },
  };

</script>

<style scoped>
#sales-order-workflow-status .list-group-item {
  padding: 0.25rem 0.5rem;
  color: #ccc;
}

#sales-order-workflow-status .list-group-item.active {
  background-color: #28a745;
  border-color: #28a745;
  color: #fff;
}

#sales-order-workflow-status .list-group-item.active:before {
  content: '✓';
  margin-right: 0.25rem;
}


.selector-link {
  color: #20a8d8 !important;
  font-size: 100%;
  font-weight: 700;
  padding-bottom: 1px;
}

.selector-link:hover {
  color: #167495 !important;
  text-decoration: underline !important;
  cursor: pointer;
}
</style>
